"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IntegrationType;
(function (IntegrationType) {
    IntegrationType["AbTest"] = "abtests";
    IntegrationType["Segment"] = "segments";
})(IntegrationType = exports.IntegrationType || (exports.IntegrationType = {}));
var IntegrationProvider;
(function (IntegrationProvider) {
    IntegrationProvider["Adobe"] = "adobe";
    IntegrationProvider["AdobeV2"] = "adobe2.0";
    IntegrationProvider["Google360"] = "google360";
    IntegrationProvider["Kameleoon"] = "kameleoon";
    IntegrationProvider["Monetate"] = "monetate";
})(IntegrationProvider = exports.IntegrationProvider || (exports.IntegrationProvider = {}));
var SegmentProvider;
(function (SegmentProvider) {
    SegmentProvider["Adobe"] = "adobe";
    SegmentProvider["AdobeV2"] = "adobe2.0";
    SegmentProvider["Google360"] = "google360";
})(SegmentProvider = exports.SegmentProvider || (exports.SegmentProvider = {}));
var ABTestProvider;
(function (ABTestProvider) {
    ABTestProvider["Fake"] = "fake";
    ABTestProvider["Kameleoon"] = "kameleoon";
    ABTestProvider["Monetate"] = "monetate";
})(ABTestProvider = exports.ABTestProvider || (exports.ABTestProvider = {}));
var IntegrationStatus;
(function (IntegrationStatus) {
    IntegrationStatus["Pending"] = "pending";
    IntegrationStatus["Error"] = "error";
    IntegrationStatus["Incomplete"] = "incomplete";
    IntegrationStatus["Success"] = "success";
    IntegrationStatus["Partial"] = "partial";
})(IntegrationStatus = exports.IntegrationStatus || (exports.IntegrationStatus = {}));
var IntegrationSteps;
(function (IntegrationSteps) {
    IntegrationSteps["Definition"] = "definition";
    IntegrationSteps["Configuration"] = "configuration";
    IntegrationSteps["Selection"] = "selection";
    IntegrationSteps["Ready"] = "";
})(IntegrationSteps = exports.IntegrationSteps || (exports.IntegrationSteps = {}));
const MAX_SEGMENT_INTEGRATIONS = 2;
const MAX_ABTEST_INTEGRATIONS = 1;
exports.MAX_INTEGRATION_PER_PROVIDER = {
    [IntegrationProvider.Adobe]: MAX_SEGMENT_INTEGRATIONS,
    [IntegrationProvider.AdobeV2]: MAX_SEGMENT_INTEGRATIONS,
    [IntegrationProvider.Google360]: MAX_SEGMENT_INTEGRATIONS,
    [IntegrationProvider.Kameleoon]: MAX_ABTEST_INTEGRATIONS,
    [IntegrationProvider.Monetate]: MAX_ABTEST_INTEGRATIONS,
};
exports.MAX_INTEGRATION_PER_TYPE = {
    [IntegrationType.AbTest]: 1,
    [IntegrationType.Segment]: Infinity
};
//# sourceMappingURL=integrations.js.map